import { Modal } from "antd"
import React from "react"
import GenericButton from "./GenericButton"

export default function GenericModal({ forceRender = false, ...props }) {
  return (
    <>
      <Modal
        centered
        open={props.visibleState}
        footer={null}
        onCancel={() => props.updateVisibility()}
        closeIcon={props.closeIcon}
        className={props.rootClassAntCustom}
        zIndex={props.zIndex}
        closable={props.closeIconVisible}
        wrapClassName={props.wrapClassName}
        forceRender={forceRender}
        transitionName=""
      >
        {props.component}
        {props.showButton ? <GenericButton title={props.buttonText} buttonStyle={props.buttonStyle} onClick={() => props.buttononClick()} className={props.buttonWrapper} /> : ""}
      </Modal>
    </>
  )
}
